import styled from 'styled-components';

const DetailAddonInfoLeftContainer = styled.div<React.CSSProperties>`
  height: 100%;
  width: 50%;
  float: left;
`;

export default DetailAddonInfoLeftContainer;
